import * as React from "react";
import { SelectionBoxRadio, RichTextArea } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/iris-ui";
import { PricingBadge } from "../../../../../PricingBadge/modules/EcommContent/components/PurchaseTypeSelectionBoxes/components/PricingBadge/PricingBadge.js";
/* empty css                              */
const PurchaseTypeSelectionBox = ({
  value,
  isSelected,
  title,
  description,
  badgePrice,
  onChange,
  "data-t": dataT
}) => /* @__PURE__ */ React.createElement(
  SelectionBoxRadio,
  {
    className: "purchase-type-selection-box",
    name: "purchase-type-selection-box",
    value,
    checked: isSelected,
    onChange: () => onChange(value),
    "aria-label": title,
    "aria-describedby": `${value}_badge ${value}_description`,
    "data-t": dataT
  },
  /* @__PURE__ */ React.createElement("div", { className: "purchase-type-selection-box__heading" }, /* @__PURE__ */ React.createElement(Text, { className: "purchase-type-selection-box__title", variant: "body-head" }, title), badgePrice && /* @__PURE__ */ React.createElement(
    PricingBadge,
    {
      purchaseTypePrice: badgePrice,
      id: `${value}_badge`,
      className: "purchase-type-selection-box__badge"
    }
  )),
  description && /* @__PURE__ */ React.createElement(
    RichTextArea,
    {
      id: `${value}_description`,
      className: "purchase-type-selection-box__description",
      content: description
    }
  )
);
export {
  PurchaseTypeSelectionBox
};
//# sourceMappingURL=PurchaseTypeSelectionBox.js.map
